import { Injector, ModuleWithProviders, NgModule, inject, provideAppInitializer } from '@angular/core';
import { Config, ConfigInitializerService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MobileMenuStatePersistenceService } from './mobile-menu-state-persistence.service';
import { MobileMenuStoreModule } from './store/mobile-menu-store.module';

function statePersistenceFactory(injector: Injector): () => Observable<Config> {
  return () => {
    const catalogStatePersistenceService = injector.get(MobileMenuStatePersistenceService);
    const configInit = injector.get(ConfigInitializerService);

    return configInit.getStable('context').pipe(
      tap(() => {
        catalogStatePersistenceService.sync();
      }),
    );
  };
}

@NgModule({
  imports: [MobileMenuStoreModule],
})
export class MainMobileMenuDataAccessModule {
  static forRoot(): ModuleWithProviders<MainMobileMenuDataAccessModule> {
    return {
      ngModule: MainMobileMenuDataAccessModule,
      providers: [
        provideAppInitializer(() => {
          const initializerFn = statePersistenceFactory(inject(Injector));

          return initializerFn();
        }),
      ],
    };
  }
}
